var GameConfig = { mainGameBoard: { width: 1920, height: 1080 } };
